(function (angular) {
    angular.module('shared').directive('preventMultiClicks', function ($window) {
        return {            
            restrict: 'A',
            link: function (scope, elm, attrs, ctrl) {                
                if (elm) {
                    elm.first().on('click', function(e) {
                        var lastClick = scope['preventMultiClicks-lastClick'];

                        if (lastClick && (Date.now() - lastClick.getTime()) < 1000) {
                            // console.log('---clicks too fast---');
                            e.preventDefault();
                            e.stopImmediatePropagation();
                        } else {
                            scope['preventMultiClicks-lastClick'] = new Date();
                        }
                    });
                }
                
            }
        };
    });

}(angular));